import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { formatPhoneNumber } from '../ops/components/PhoneInput';

export const Footer = () => {
  const { settings, loading } = useSiteSettings();

  if (loading || !settings) {
    return null; // Or return a loading skeleton
  }

  return (
    <footer className="bg-[#0A0A0A] border-t border-gray-800 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and tagline */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/3fqxm7r4_BuildBroz_Logo.png" 
              alt="BuildBroz Logo" 
              className="h-20 w-auto"
            />
            <p className="text-[#D4AF37] text-lg font-semibold italic">
              "{settings.slogan}"
            </p>
            <p className="text-gray-400 text-sm">
              Building dreams into reality with quality craftsmanship and dedication.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#D4AF37] font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Project Gallery
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-[#D4AF37] font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Kitchen Remodeling</li>
              <li className="text-gray-400 text-sm">Bathroom Renovation</li>
              <li className="text-gray-400 text-sm">Home Additions</li>
              <li className="text-gray-400 text-sm">Basement Finishing</li>
              <li className="text-gray-400 text-sm">Roofing & Siding</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[#D4AF37] font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <Phone size={16} className="text-[#D4AF37]" />
                <a href={`tel:${settings.phone1.replace(/[^0-9]/g, '')}`} className="hover:text-[#D4AF37] transition-colors">
                  {formatPhoneNumber(settings.phone1)}
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <Phone size={16} className="text-[#D4AF37]" />
                <a href={`tel:${settings.phone2.replace(/[^0-9]/g, '')}`} className="hover:text-[#D4AF37] transition-colors">
                  {formatPhoneNumber(settings.phone2)}
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <Mail size={16} className="text-[#D4AF37]" />
                <a href={`mailto:${settings.email}`} className="hover:text-[#D4AF37] transition-colors">
                  {settings.email}
                </a>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <MapPin size={16} className="text-[#D4AF37] mt-1" />
                <span>Serving {settings.service_area}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} {settings.company_name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};